import {
  HttpContextToken,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

/**
 * Set on a request whose caller handles a 401 itself and must keep the page
 * (BPA-860): the redirect below would destroy the component holding unsaved
 * input. Defaults to `false`, so every other request still redirects. The error
 * is rethrown either way.
 */
export const SKIP_AUTH_REDIRECT = new HttpContextToken<boolean>(() => false);

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.context.get(SKIP_AUTH_REDIRECT)) {
        // Redirect to home or login on unauthorized
        router.navigate(['/']);
      }

      if (error.status === 403) {
        router.navigate(['/access-denied']);
      }

      return throwError(() => error);
    }),
  );
};
